import { render, staticRenderFns } from "./cookieModal.vue?vue&type=template&id=abed961e&scoped=true&"
import script from "./cookieModal.vue?vue&type=script&lang=js&"
export * from "./cookieModal.vue?vue&type=script&lang=js&"
import style0 from "./cookieModal.vue?vue&type=style&index=0&id=abed961e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abed961e",
  null
  
)

export default component.exports